export default __webpack_public_path__ + "static/media/3.440579c0.png";